import { render, staticRenderFns } from "./ProfessionSpecPharmaField.vue?vue&type=template&id=03db99c8"
import script from "./ProfessionSpecPharmaField.vue?vue&type=script&lang=js"
export * from "./ProfessionSpecPharmaField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports